const APPOINTMENTS_ROUTES = {
  APPOINTMENTS: '/appointments',
  APPOINTMENTS_PERSONAL_DATA: '/appointments/personal-data',
  APPOINTMENTS_RESERVE: '/appointments/reserve',
  APPOINTMENTS_CHECKOUT: '/appointments/checkout',
};

const PROFILE_ROUTES = {
  PROFILE: '/profile',
  PROFILE_SETUP: '/profile-setup',
};

const WELL_BEING_ROUTES = {
  WELL_BEING: '/well-being',
  WELL_BEING_CONTENT: '/well-being/:id',
  WELL_BEING_ARTICLE: '/well-being/articles/:id',
  WELL_BEING_TEST: '/well-being/test',
  WELL_BEING_TEST_DETAIL: '/well-being/test/:surveyId',
  WELL_BEING_BAROMETER: '/well-being/barometer',
};

export const CHAT_ROUTES = {
  CHAT: '/chat',
  CHAT_REPORT: '/chat-report',
};

const PSYCHOLOGIST_ROUTES = {
  PSYCHOLOGIST_PATIENTS: '/psychologist-patients',
  PATIENT_PROFILE: '/psychologist-patients/:id/profile',
  PATIENT_APPOINTMENTS: '/psychologist-patients/:id/appointments/:appointmentId',
};

export const PUBLIC_ROUTES = {
  LOGIN: '/login',
  MAGIC_LINK: '/login/link',
  REGISTER: '/register',
  RECOVER_PASSWORD: '/recover-password',
};

const SAPA_ROUTES = {
  SAPA: '/sapa',
  SAPA_CHAT: '/sapa-chat',
};

export const PRIVATE_ROUTES = {
  HOME: '/home',
  PAE: '/pae',
  ...SAPA_ROUTES,
  ...APPOINTMENTS_ROUTES,
  ...PROFILE_ROUTES,
  ...WELL_BEING_ROUTES,
  ...CHAT_ROUTES,
  ...PSYCHOLOGIST_ROUTES,
};

export const ROUTES = {
  ROOT: '/',
  ...PUBLIC_ROUTES,
  ...PRIVATE_ROUTES,
};
